import { Injectable } from '@angular/core';
import { Factory } from './factory.interface';

@Injectable()
export class GenericFactory implements Factory {
    constructor() { }
    createInstance<T, C>(json: T, Class: new (json: T) => C): C {
        let instance: C;
        if (Class)
            instance = new Class(json);
        return instance;
    }
    createInstances<T, C>(jsons: T[], Class: new (json: T) => C): C[] {
        let instances: C[] = [];
        jsons.forEach(json => {
            instances.push(this.createInstance(json, Class));
        });
        return instances;
    }
    deps() {
        return [];
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Factories/generic-factory.ts